import { render } from "./StudentDetails.vue?vue&type=template&id=2ace04ec&scoped=true"
import script from "./StudentDetails.vue?vue&type=script&lang=js"
export * from "./StudentDetails.vue?vue&type=script&lang=js"

import "./StudentDetails.vue?vue&type=style&index=0&id=2ace04ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ace04ec"]])

export default __exports__